import React from 'react';

import { format } from 'date-fns';
import { theme } from 'fpay-ui';

import { REGIONS } from '@constants/regions';
import {
  FORMAT_TYPE_MOVEMENT_AUTHORIZATION,
  TYPE_MOVEMENT_AUTHORIZATION,
  FORMAT_SOFT_DESCRIPTOR_MOVEMENT_AUTHORIZATION,
  SOFT_DESCRIPTOR_MOVEMENT_AUTHORIZATION,
} from '@constants/transactions';
import { getEnv } from '@config';

const { country } = getEnv();

export const getFormatedDate = (date) => format(new Date(date), 'dd-MM-yyyy');

export const getDescriptionByType = (type) => {
  switch (type) {
    case TYPE_MOVEMENT_AUTHORIZATION.TED_CASH_IN:
    case TYPE_MOVEMENT_AUTHORIZATION.TED_CASH_IN_ADVANCEMENTS:
      return 'modalTable.modal.payOrder';
    case TYPE_MOVEMENT_AUTHORIZATION.TED_CASH_OUT:
      return 'modalTable.modal.fundWithdrawal';
    case TYPE_MOVEMENT_AUTHORIZATION.CARGO_SALDO:
      return 'modalTable.modal.deferredTransfer';

    default:
      return type;
  }
};

export const getFormatedType = (type) => {
  switch (type) {
    case TYPE_MOVEMENT_AUTHORIZATION.TED_CASH_IN:
    case TYPE_MOVEMENT_AUTHORIZATION.TED_CASH_IN_ADVANCEMENTS:
      return FORMAT_TYPE_MOVEMENT_AUTHORIZATION.INGRESO;
    case TYPE_MOVEMENT_AUTHORIZATION.TED_CASH_OUT:
    case TYPE_MOVEMENT_AUTHORIZATION.CARGO_SALDO:
      return FORMAT_TYPE_MOVEMENT_AUTHORIZATION.EGRESO;
    case TYPE_MOVEMENT_AUTHORIZATION.CARGO_SALDO_REGULARIZADO:
      return FORMAT_TYPE_MOVEMENT_AUTHORIZATION.EGRESO;
    case TYPE_MOVEMENT_AUTHORIZATION.INGRESO_DE_SALDO:
      return FORMAT_TYPE_MOVEMENT_AUTHORIZATION.INGRESO;
    case TYPE_MOVEMENT_AUTHORIZATION.EGRESO_DE_SALDO:
      return FORMAT_TYPE_MOVEMENT_AUTHORIZATION.EGRESO;
    case TYPE_MOVEMENT_AUTHORIZATION.CANCEL_EGRESO_DE_SALDO:
      return FORMAT_TYPE_MOVEMENT_AUTHORIZATION.INGRESO;
    case TYPE_MOVEMENT_AUTHORIZATION.CANCEL_INGRESO_DE_SALDO:
      return FORMAT_TYPE_MOVEMENT_AUTHORIZATION.EGRESO;
    case TYPE_MOVEMENT_AUTHORIZATION.PAGO_DE_CUOTA_DE_CREDITO:
      return FORMAT_TYPE_MOVEMENT_AUTHORIZATION.EGRESO;
    case TYPE_MOVEMENT_AUTHORIZATION.CANCELACION_DE_PAGO:
      return FORMAT_TYPE_MOVEMENT_AUTHORIZATION.INGRESO;
    case TYPE_MOVEMENT_AUTHORIZATION.CANCEL_CARGO_SALDO:
      return FORMAT_TYPE_MOVEMENT_AUTHORIZATION.INGRESO;
    default:
      return type;
  }
};

export const getFormatedSoftDescriptor = (type) => {
  switch (type) {
    case SOFT_DESCRIPTOR_MOVEMENT_AUTHORIZATION.TEF_CASH_OUT:
      return FORMAT_SOFT_DESCRIPTOR_MOVEMENT_AUTHORIZATION.TRANSFERENCIA;
    case SOFT_DESCRIPTOR_MOVEMENT_AUTHORIZATION.TED_CASH_OUT:
      return FORMAT_SOFT_DESCRIPTOR_MOVEMENT_AUTHORIZATION.RETIRO;
    case SOFT_DESCRIPTOR_MOVEMENT_AUTHORIZATION.ORDEN_PAGO:
      return FORMAT_SOFT_DESCRIPTOR_MOVEMENT_AUTHORIZATION.ORDEN;
    case SOFT_DESCRIPTOR_MOVEMENT_AUTHORIZATION.TED_CASH_IN:
    case SOFT_DESCRIPTOR_MOVEMENT_AUTHORIZATION.TED_CASH_IN_ADVANCEMENTS:
      return FORMAT_SOFT_DESCRIPTOR_MOVEMENT_AUTHORIZATION.ORDEN;
    default:
      return type;
  }
};

export const getFormatedDetail = (type) =>
  // eslint-disable-next-line no-nested-ternary
  type === TYPE_MOVEMENT_AUTHORIZATION.TED_CASH_IN
    ? 'Crédito'
    : type === TYPE_MOVEMENT_AUTHORIZATION.TED_CASH_OUT
    ? 'Débito'
    : type;

export const getFormatedMoneyRed = (amount) => {
  let decimalCount = Math.abs(REGIONS[country].decimalCount);
  // eslint-disable-next-line no-restricted-globals
  decimalCount = isNaN(decimalCount) ? 2 : decimalCount;
  const negativeSign =
    amount < 0 ? `-${REGIONS[country].currencySymbol} ` : `${REGIONS[country].currencySymbol} `;
  // eslint-disable-next-line radix
  const i = parseInt((amount = Math.abs(Number(amount) || 0).toFixed(decimalCount))).toString();
  const j = i.length > 3 ? i.length % 3 : 0;

  return (
    <span style={{ color: `${theme.colors.gray800}` }}>
      {negativeSign +
        (j ? i.substr(0, j) + REGIONS[country].thousandSeparator : '') +
        i.substr(j).replace(/(\d{3})(?=\d)/g, `$1${REGIONS[country].thousandSeparator}`) +
        (decimalCount
          ? REGIONS[country].decimalSeparator +
            Math.abs(amount - i)
              .toFixed(decimalCount)
              .slice(2)
          : '')}
    </span>
  );
};

export const getFormatedMoneyGreen = (amount, textColor) => {
  let decimalCount = Math.abs(REGIONS[country].decimalCount);
  // eslint-disable-next-line no-restricted-globals
  decimalCount = isNaN(decimalCount) ? 2 : decimalCount;
  const positiveSign =
    amount < 0 ? `-${REGIONS[country].currencySymbol} ` : `${REGIONS[country].currencySymbol} `;
  // eslint-disable-next-line radix
  const i = parseInt((amount = Math.abs(Number(amount) || 0).toFixed(decimalCount))).toString();
  const j = i.length > 3 ? i.length % 3 : 0;

  return (
    <span style={{ color: `${textColor || theme.colors.gbrand600}` }}>
      {positiveSign +
        (j ? i.substr(0, j) + REGIONS[country].thousandSeparator : '') +
        i.substr(j).replace(/(\d{3})(?=\d)/g, `$1${REGIONS[country].thousandSeparator}`) +
        (decimalCount
          ? REGIONS[country].decimalSeparator +
            Math.abs(amount - i)
              .toFixed(decimalCount)
              .slice(2)
          : '')}
    </span>
  );
};

// TODO: used locale.moneyFormat
export const getFormatedMoneyIn = (amount, textColor) => {
  let decimalCount = Math.abs(REGIONS[country].decimalCount);
  // eslint-disable-next-line no-restricted-globals
  decimalCount = isNaN(decimalCount) ? 2 : decimalCount;
  const positiveSign =
    amount < 0 ? `-${REGIONS[country].currencySymbol} ` : `${REGIONS[country].currencySymbol} `;
  // eslint-disable-next-line radix
  const i = parseInt((amount = Math.abs(Number(amount) || 0).toFixed(decimalCount))).toString();
  const j = i.length > 3 ? i.length % 3 : 0;

  return (
    <>
      <span style={{ color: `${textColor || '#434B62'}` }}>+ </span>
      <span style={{ color: `${textColor || '#434B62'}` }}>
        {positiveSign +
          (j ? i.substr(0, j) + REGIONS[country].thousandSeparator : '') +
          i.substr(j).replace(/(\d{3})(?=\d)/g, `$1${REGIONS[country].thousandSeparator}`) +
          (decimalCount
            ? REGIONS[country].decimalSeparator +
              Math.abs(amount - i)
                .toFixed(decimalCount)
                .slice(2)
            : '')}
      </span>
    </>
  );
};

// TODO: used locale.moneyFormat
export const getFormatedMoneyOut = (amount, textColor) => {
  let decimalCount = Math.abs(REGIONS[country].decimalCount);
  // eslint-disable-next-line no-restricted-globals
  decimalCount = isNaN(decimalCount) ? 2 : decimalCount;
  const positiveSign =
    amount < 0 ? `-${REGIONS[country].currencySymbol} ` : `${REGIONS[country].currencySymbol} `;
  // eslint-disable-next-line radix
  const i = parseInt((amount = Math.abs(Number(amount) || 0).toFixed(decimalCount))).toString();
  const j = i.length > 3 ? i.length % 3 : 0;

  return (
    <>
      <span style={{ color: `${textColor || '#434B62'}` }}>- </span>
      <span style={{ color: `${textColor || '#434B62'}` }}>
        {positiveSign +
          (j ? i.substr(0, j) + REGIONS[country].thousandSeparator : '') +
          i.substr(j).replace(/(\d{3})(?=\d)/g, `$1${REGIONS[country].thousandSeparator}`) +
          (decimalCount
            ? REGIONS[country].decimalSeparator +
              Math.abs(amount - i)
                .toFixed(decimalCount)
                .slice(2)
            : '')}
      </span>
    </>
  );
};
